// cotty brand assets for the connection animation.
// The ASCII banner + decode glyph pool are lifted verbatim from the
// cotty.sh hero so the connecting screen matches the marketing site.

/** The COTTY ANSI-shadow banner (6 lines), byte-identical to cotty.sh. */
export const COTTY_BANNER = [
    " ██████╗ ██████╗ ████████╗████████╗██╗   ██╗",
    "██╔════╝██╔═══██╗╚══██╔══╝╚══██╔══╝╚██╗ ██╔╝",
    "██║     ██║   ██║   ██║      ██║    ╚████╔╝",
    "██║     ██║   ██║   ██║      ██║     ╚██╔╝",
    "╚██████╗╚██████╔╝   ██║      ██║      ██║",
    " ╚═════╝ ╚═════╝    ╚═╝      ╚═╝      ╚═╝   ",
].join("\n");

/** Scramble glyphs used by the Watch_Dogs-style decode effect (from cotty.sh). */
export const DECODE_GLYPHS = "01/\\<>[]{}#%$&*+=~^|:;!?\u2591\u2592".split("");

